module.exports = __webpack_public_path__ + "img/icon_05.34b1b7fd.gif";